<template>
    <div class="mobileselector" style="margin: 0 10px;">
        <!-- TODO: make textbox insides white -->
        <component :is="autocomplete ? 'v-autocomplete' : 'v-select'" :value="value" :items="items" :label="label"
            :multiple="multiple" @change="filter.select" outlined chips dense small-chips :deletable-chips="multiple"
            :menu-props="{maxHeight: autocomplete ? 150 : 304}" :attach="true">
            <template v-slot:selection="{ item, index }">
                <!-- One item selected (and you can select only one.) -->
                <span v-if="typeof value !== 'object'" style="margin-right:0.5em;">
                    <span v-if="!item.text" style="font-style: italic;">(None Specified)</span>
                    <span v-else>{{item.text}}</span>
                </span>
                <!-- One item is selected (from multiple.) -->
                <span v-else-if="value && (value.length === 1) && item" style="margin-right:0.5em;">
                    <span v-if="!item.text" style="font-style: italic;">(None Specified)</span>
                    <span v-else>{{item.text}}</span>
                </span>
                <!-- Multiple selected, group. -->
                <span v-else-if="value && (value.length > 1)">
                    <!-- Only write this value once. -->
                    <span v-if="index===0" style="margin-right:0.5em;">({{value.length}} Selected)</span>
                </span>
                <!-- Fallback -->
                <span v-else></span>
            </template>
            <template v-if="multiple" v-slot:prepend-item>
                <!-- FIXME: Padding hack, differs from localhost and build. -->
                <v-list-item ripple class="px-4" @click="toggle">
                    <v-list-item-action>
                        <v-simple-checkbox :value="selectedAll" color="primary" @click="toggle"></v-simple-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            Select All / Deselect All
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
            </template>
            <template v-slot:item="{item}">
                <!-- FIXME: Padding hack, differs from localhost and build. -->
                <v-list-item ripple class="px-4">
                    <v-list-item-action v-if="multiple">
                        <v-simple-checkbox :value="item.isSelected" color="primary"
                            @click="item.isSelected =! item.isSelected"></v-simple-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            <span v-if="!item.text" style="font-style: italic;">None Specified (placed at: 0 N, 0 E)</span>
                            <span v-else-if="item.text==='multiple'" style="font-style: italic;">Multiple Regions (placed at: 0 N, 0 E)</span>
                            <span v-else>{{item.text}}</span>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
            </template>
            <template v-slot:no-data>
                <v-list-item class="px-4 py-1">
                    <v-list-item-content>
                        <span class="text-center text--secondary" style="font-size: 13px;">No data available</span>
                    </v-list-item-content>
                </v-list-item>
            </template>
        </component>
    </div>
</template>

<script>
    import { Items } from '../../ts/filters'


    export default {
        props: {
            filter: {
                required: false,
                type: Items,
                default: () => []
            },
			sortItemsCaseInsensitive: {
				required: false,
				type: Boolean,
				default: false
			},
            label: {
                required: false,
                type: String,
                default: ""
            },
            multiple: { // TODO: this should probably live in filter logic!
                required: false,
                type: Boolean,
                default: true
            },
            autocomplete: { // TODO: this should probably live in filter logic!
                required: false,
                type: Boolean,
                default: false
            },
        },
        computed: {
            value() {
                const selected = this.filter.getSelected("value")
                return this.multiple ? selected : selected[0]
            },
            selectedAll() {
                return (this.value.length === this.filter.getAll("value").length)
            },
            items() {
                if (this.sortItemsCaseInsensitive) {
					// Sort alphabetically (case insensitive)
					return this.filter.getAll().sort((a,b) =>
                        (a.value.toLowerCase() > b.value.toLowerCase()) ? 1 : ((b.value.toLowerCase() > a.value.toLowerCase()) ? -1 : 0));
				}
				else {
                    return this.filter.getAll().sort((a, b) => {
                        // Move 'Multiple Regions (placed at: 0 N, 0 E)' to the end
                        // In the list this is held as 'multiple' but rendered as 'Multiple Regions (placed at: 0 N, 0 E)'
						if (a.value === 'multiple') return 1;
						if (b.value === 'multiple') return -1;
						
						// push items with numbers or empty values to the end
						const aHasNumber = /\d/.test(a.value);
						const bHasNumber = /\d/.test(b.value);
						if ((aHasNumber || !a.value) && !bHasNumber) return 1;
						if (!aHasNumber && (bHasNumber || !b.value)) return -1;
						
						return 0;
                    })
                }
            },
        },
        methods: {
            // required(value) {
            //     // Catch missed fail states
            //     if (typeof value === 'object' && !value.length) { return false }

            //     // Default success
            //     if (value) { return true }

            //     // Catch missed win states
            //     if (value === 0) { return true }

            //     // Default fail
            //     return false
            // },
            toggle() {
                if (!this.selectedAll) {
                    this.filter.select(this.filter.getAll("value"))
                } else {
                    this.filter.select([])
                }
            }
        }
    }
</script>

<style>
    .mobileselector .v-select__selections {
        margin: 5px 0 2px 0 !important;
    }
</style>